// @flow

import React from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';
import UploadFileList from './UploadFileList';

type Props = {
  isSending: boolean,
  isError: boolean,
  onSendContent: (message: string, files: Array<File>) => void,
};

type State = {
  message: string,
  files: Array<File>,
};

export class NewMessage extends React.Component<Props, State> {
  props: Props;
  state: State;

  _file: ?HTMLInputElement;

  constructor(props: Props) {
    super(props);

    this.state = {
      message: '',
      files: [],
    };
  }

  componentDidMount() {
    if (this._file) {
      this._file.addEventListener('change', this.onFilesSelected);
    }
  }

  componentWillUnmount() {
    if (this._file) {
      this._file.removeEventListener('change', this.onFilesSelected);
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.isSending && !nextProps.isSending && !nextProps.isError) {
      this.setState({
        message: '',
        files: [],
      });
    }
  }

  onMessageChange = event => {
    this.setState({
      message: event.target.value,
    });
  };

  onSend = () => {
    const { message, files } = this.state;
    if (message.length > 0 || files.length > 0) {
      this.props.onSendContent(message, files);
    }
  };

  onSelectFiles = () => {
    if (this._file != null) {
      this._file.click();
    }
  };

  onFilesSelected = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const { files } = event.target;

    if (files != null && files.length > 0) {
      // Mapping input FileList to array
      const filesArray = [];
      for (let i = 0; i < files.length; i++) {
        filesArray[i] = files.item(i);
      }

      this.setState(state => ({
        files: [...state.files, ...filesArray],
      }));
    }
  };

  onCleanPreviousFile = event => {
    event.target.value = null;
  };

  onRemoveFile = (file: File) =>
    this.setState(state => ({
      files: state.files.filter(f => f.name !== file.name),
    }));

  onKeyDown = event => {
    if (event.keyCode === 13 && !event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();

      this.onSend();
    }
  };

  render() {
    const { isSending, isError } = this.props;
    const { message, files } = this.state;

    const canSend = message.length > 0 || files.length > 0;

    return (
      <div className="messages-footer">
        <UploadFileList files={files} onRemoveFile={this.onRemoveFile} />
        <Segment className="new-message-container">
          <div>
            <input
              type="file"
              style={{ display: 'none' }}
              multiple
              ref={ref => (this._file = ref)}
              onClick={this.onCleanPreviousFile}
            />
            <Button icon="image" onClick={this.onSelectFiles} />
          </div>
          <div>
            <Form>
              <Form.Field>
                <textarea
                  placeholder="Ecrivez votre message..."
                  value={message}
                  rows={1}
                  onChange={this.onMessageChange}
                  onKeyDown={this.onKeyDown}
                />
              </Form.Field>
            </Form>
          </div>
          <div>
            <Button
              circular
              icon={isError ? 'exclamation' : 'send'}
              color={isError ? 'red' : undefined}
              loading={isSending}
              disabled={isSending || !canSend}
              onClick={this.onSend}
            />
          </div>
        </Segment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/messaging/components/messages/NewMessage.js